import { getheader, serverUrl } from "./CommonFunctions";
const getPostHeader = () => {
    var myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/json');
    myHeaders.append('token', localStorage.getItem('token'))
    window._header = myHeaders;
    return myHeaders;
}
export function getHappycallQuestionList() {
    return dispatch => {
        dispatch({
            type: "LOADING",
            data: true
        });
        fetch(serverUrl + "api/HappycallAPI/GetHappycallQuestionList?categoryID=3", {
            method: "GET",
            cache: "default",
            headers: getheader()
        })
            .then(res => res.json())
            .then(res => {
                dispatch({
                    type: "LOADING",
                    data: false
                });
                if (res === "ERROR") {
                    alert("اشکال در دریافت اطلاعات");
                    return;
                }
                return dispatch({
                    type: "FETCH_HAPPYCALL_ANSWERS",
                    data: res
                })
            })
    }
}
export function saveHappycallResult(data, fn) {
    const _header = getPostHeader();
    return dispatch => {
        dispatch({
            type: "LOADING",
            data: true
        });
        data = JSON.stringify(data);
        fetch(serverUrl + "api/HappycallAPI/AddHappycallResult/", {
            body: data,
            headers: _header,
            method: 'POST',
            cache: 'default'
        }).then(res => res.json())
            .then(res => {
                dispatch({
                    type: "LOADING",
                    data: false
                });
                if (res === "Success") {
                    fn();
                }
                else if (res.Message === "NotFound") {
                    alert("سرویسی برای این کالا انجام نشده است");
                }
                else if (res.Message === "HasHappycall") {
                    alert("نظرسنجی قبلا برای این سریال ثبت شده است");
                }
                else if (res.Message === "ServiceNotDone") {
                    alert("سرویس در وضعیت موفق قرار ندارد");
                }
                else {
                    alert("اشکال در انجام عملیات");
                }
            }).catch(e => console.log("[AddHappycallResult]", e));
    }
}